<template>
  <div>
    <icon-view
      gradient
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-map-marker-alt color-orange mb-1"
      title="Información de Locación"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
    />
    <validation-observer disabled ref="regionForm">
      <label class="font-weight-bold">Seleccione Región(es):</label>
      <div class="row">
        <div class="col-12 col-md-4 border-right">
          <div>
            <span class="data-title d-block mb-2">
              Región(es):
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="region"
              rules="required"
            >
              <custom-drop-down
                v-model="current.region"
                id="region"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="La región es requerida."
                :error="errors[0]"
                :options="options"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="mt-3">
            <span class="data-title d-block mb-2">
              Lugar:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="locationName"
              rules="required"
            >
              <custom-input
                v-model="current.locationName"
                id="locationName"
                maxlength="256"
                custom-error-msg="El lugar es requerido."
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <action-button
            id="btn-add"
            type="button"
            text="Añadir"
            i="fas fa-file-plus"
            variant="success"
            class="ml-2 px-4 mb-3 mt-3 float-right actionButton"
            :disabled="readOnly"
            @click="add"
          />
        </div>
        <div class="col-12 col-md-8">
          <span class="data-title d-block mb-2">
            Lugar(es) Seleccionado(s):
          </span>
          <div
            class="specialist-item py-1 px-4 mb-2 mr-2 d-inline-block"
            v-for="(item, key) in model"
            :key="key"
          >
            <div class="d-flex">
              <div class="mr-3">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ item.region.name }}
                </span>
                <small class="text-muted">
                  {{ item.locationName }}
                </small>
              </div>
              <div class="align-self-center text-center">
                <i
                  id="removed-icon"
                  class="far fa-times-circle text-red cursor-pointer"
                  @click="remove(key)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from "icon-view";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import CustomChipsGroup from "CustomChipsGroup";

import locationService from "@/services/api/materialsEquipment.api";

export default {
  name: "LocationInfo",
  components: {
    IconView,
    CustomDropDown,
    ActionButton,
    CustomInput,
    CustomChipsGroup
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    regions: {
      type: Array,
      default: () => []
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      current: { region: null, locationName: null }
    };
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    options() {
      const selected = this.model.map(x => x.id);
      return this.regions.filter(x => !selected.includes(x.id));
    }
  },
  async mounted() {
    await this.getRegions();
    this.model = this.value;
  },
  methods: {
    async getRegions() {
      if (this.regions.length) return;
      const { data } = await locationService.getRegions();
      const regions = data?.map(({ id, name }) => ({ id, name })) ?? [];
      this.$emit("update:regions", regions);
    },
    async add() {
      const valid = await this.$refs.regionForm.validate();
      if (!valid) return;

      const { region, locationName } = this.current;
      const exits = this.model
        .filter(x => x.region.id === region.id)
        .some(x => x.locationName === locationName);
      if (exits) return;

      this.model.push({ region, locationName });
      this.current.region = null;
      this.current.locationName = null;
      await this.$refs.regionForm.reset();
    },
    remove(key) {
      if (this.readOnly) return;
      this.model.splice(key, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.specialist-item {
  border-radius: 50px;
  border: 1px solid rgb(220, 220, 220);
  width: fit-content;
  font-size: 90%;
}
.align-self-center {
  align-self: center !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
